import { FC, useEffect } from 'react'
import { Router } from 'next/router'
import {
  useExperimentBoolean,
  useExperimentInteger,
} from '@moonpig/web-core-eppo/browser'
import { initMixpanel, trackPageView } from './mixpanelClient'

export const MixpanelSetup: FC<{ url: string }> = ({ url }) => {
  const mixpanelRecordingPercent = useExperimentInteger(
    'mixpanel-recording-percent',
    {
      fallback: 0,
    },
  )

  const mixpanelEnabled = useExperimentBoolean('mixpanel-enabled', {
    fallback: false,
  })

  useEffect(() => {
    const isWorkPage = url && url.match(/^\/[a-z]{2,2}\/(business|work)/)
    if (isWorkPage && mixpanelEnabled) {
      initMixpanel(mixpanelRecordingPercent)

      const handleRouteChange = (newUrl: string) => {
        trackPageView(newUrl) // Track pageviews
      }

      Router.events.on('routeChangeComplete', handleRouteChange)
      return () => {
        Router.events.off('routeChangeComplete', handleRouteChange)
      }
    }
  }, [url, mixpanelEnabled, mixpanelRecordingPercent])

  return null
}
